import { createBoundContext } from '@bonusly/design-system';

import { Feedback } from '../../lib';

export const [EvaluationContext, useEvaluation] = createBoundContext<Feedback>({
	providerName: 'EvaluationContext',
	hookName: 'useEvaluationContext',
});
